// extracted by mini-css-extract-plugin
export var infoSection = "_q-1";
export var infoSectionContainer = "_q-0";
export var infoSectionTitleRow = "_q-2";
export var multiLineInfo = "_q-4";
export var strong = "_q-3";